import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export function OtpGate({ token, otp, onOk }) {
  const [sent, setSent] = useState(otp.pending ? otp.email : "");
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async (fn) => {
    setBusy(true);
    try {
      await fn();
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };
  const send = () => run(async () => setSent((await api.post(`/public/sign/${token}/otp/send`)).data.email));
  const verify = () => run(async () => { await api.post(`/public/sign/${token}/otp/verify`, { code }); toast.success("Identità confermata"); onOk(); });
  return (
    <div className="rounded-xl border border-[#D4E6EC] bg-white p-6 sm:p-8 max-w-lg space-y-4" data-testid="otp-gate">
      <div className="flex items-center gap-2 font-serif-it text-2xl font-semibold"><ShieldCheck className="text-[#0B6E8F]" /> Conferma la tua identità</div>
      <p className="text-sm text-[#47606B]">Per rendere la firma ancora più sicura ti inviamo un codice di 6 cifre all'email indicata nel contratto <b>{otp.email}</b>. Dopo la conferma potrai firmare come sempre.</p>
      {!sent ? (
        <div className="flex flex-wrap gap-2">
          <Button className="rounded-full" onClick={send} disabled={busy} data-testid="otp-send">{busy ? <Loader2 size={15} className="mr-2 animate-spin" /> : <Mail size={15} className="mr-2" />} Inviami il codice</Button>
        </div>
      ) : (
        <div className="space-y-3">
          <div className="text-sm text-[#166534]" data-testid="otp-sent">Codice inviato a {sent}. Controlla anche lo spam.</div>
          <input inputMode="numeric" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} placeholder="••••••" className="w-48 text-center tracking-[0.5em] text-2xl rounded-lg border border-[#D4E6EC] px-3 py-2" data-testid="otp-code" />
          <div className="flex gap-2">
            <Button className="rounded-full" onClick={verify} disabled={busy || code.length !== 6} data-testid="otp-verify">{busy && <Loader2 size={15} className="mr-2 animate-spin" />} Conferma</Button>
            <Button variant="ghost" className="rounded-full" onClick={send} disabled={busy} data-testid="otp-resend">Invia di nuovo</Button>
          </div>
        </div>
      )}
    </div>
  );
}
